import { api } from 'src/api';
import { cast, types } from 'mobx-state-tree';
import { createAsync } from 'src/utils/asyncModel';
// import { toJS } from 'mobx';

const createTagAsync = createAsync(body => {
  return async function createTag(options) {
    const resp = await api.Tags.createTag(body, options);
    return resp;
  };
});
const getAllTagsAsync = createAsync(() => {
  return async function getAllTags(options) {
    const resp = await api.Tags.getAllTags(options);
    this.setTags(resp.response);
    return resp;
  };
});
const updateTagAsync = createAsync(body => {
  return async function updateTag(options) {
    const resp = await api.Tags.updateTag(body, options);
    return resp;
  };
});
const deleteTagAsync = createAsync(body => {
  return async function deleteTag(options) {
    const resp = await api.Tags.deleteTag(body, options);
    return resp;
  };
});
const getTagByIdAsync = createAsync(body => {
  return async function getTagById(options) {
    const resp = await api.Tags.getTagById(body, options);
    return resp;
  };
});
const removeTagsFromAccountAsync = createAsync(body => {
  return async function removeTagsFromAccount(options) {
    const resp = await api.Tags.removeTagsFromAccount(body, options);
    return resp;
  };
});
const getAllTagsByAccountIdsAsync = createAsync(body => {
  return async function getAllTagsByAccountIds(options) {
    const resp = await api.Tags.getAllTagsByAccountIds(body, options);
    return resp;
  };
});
const assignTagsToAccountAsync = createAsync(body => {
  return async function assignTagsToAccount(options) {
    const resp = await api.Tags.assignTagsToAccount(body, options);
    return resp;
  };
});
const Tag = types.model({
  id: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  color: types.maybeNull(types.string)
});
const TagsStore = types.model('TagsStore', {
  createTagAsync,
  getAllTagsAsync,
  updateTagAsync,
  deleteTagAsync,
  getTagByIdAsync,
  assignTagsToAccountAsync,
  removeTagsFromAccountAsync,
  getAllTagsByAccountIdsAsync,
  tagsList: types.optional(types.array(Tag), []),
  editableTagsList: types.optional(types.array(Tag), [])
}).views(store => ({
  getTagById(id) {
    return store.tagsList.find(i => i.id === id);
  },
  getEditableTagById(id) {
    return store.editableTagsList.find(i => i.id === id);
  }
})).actions(store => ({
  setTags(data) {
    try {
      store.tagsList = cast([]);
      store.tagsList = cast(data);
      store.editableTagsList = cast([]);
      store.editableTagsList = cast(data);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  changeEditableTag(idx, field, value) {
    try {
      const index = store.editableTagsList.findIndex(i => i.id === idx);
      store.editableTagsList[index][field] = value;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  deleteTag(id) {
    try {
      const index = store.editableTagsList.findIndex(i => i.id === id);
      store.editableTagsList.splice(index, 1);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
}));
export const tags = types.optional(TagsStore, {});